import React from 'react'

// Extend Window interface to include Cookiebot
declare global {
  interface Window {
    Cookiebot?: {
      show: () => void
    }
  }
}

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger
} from '../base/navigation-menu.js'

type NavLink = {
  label: string
  href?: string
  dropdown?: { label: string; href: string }[]
  onClick?: () => void
}

const navLinks: NavLink[] = [
  // {
  //   label: 'Sustainable Aviation',
  //   href: '/'
  //   // dropdown: [
  //   //   { label: 'Option 1', href: '/sustainable-aviation/option1' },
  //   //   { label: 'Option 2', href: '/sustainable-aviation/option2' }
  //   // ]
  // },
  // { label: 'My Bucket List', href: '/bucket-list' },
  // { label: 'Our Technology', href: '/technology' },
  // { label: 'Partners', href: '/partners' },
  // { label: 'Resources', href: '/resources' },
  // {
  //     label: 'Resources',
  //     dropdown: [
  //         { label: 'Blog', href: '/resources/blog' },
  //         { label: 'Docs', href: '/resources/docs' },
  //     ],
  // },
  // { label: 'About Us', href: '/about' },
  // { label: 'Contact', href: '/contact'
  { label: 'B2B Enquiry', href: 'http://27069761.hs-sites-eu1.com/corporate-travel-co2' },
  { label: 'Contact Us', href: 'https://taoclimate.com/contact' },
  { label: 'Support', href: 'mailto:support@taoclimate.com' },
  { label: 'Terms', href: 'https://taoclimate.com/terms-and-conditions' },
  { label: 'FAQs', href: 'https://taoclimate.com/aviation-decarbonisation-faqs' }
]

const robotoClass = 'font-roboto font-normal text-[14px] text-white'

interface NavProps {
  showPolicyLinks?: boolean
}

const Nav: React.FC<NavProps> = ({ showPolicyLinks = false }) => {
  const policyLinks: NavLink[] = [
    {
      label: 'Cookies',
      onClick: () => {
        window.Cookiebot?.show()
      }
    },
    { label: 'Cookie Policy', href: 'https://taoclimate.com/cookie-policy-for-app-taoclimate-com' },
    { label: 'Privacy Policy', href: 'https://taoclimate.com/privacy-policy' },
    {
      label: 'AI Policy',
      href: 'https://taoclimate.com/tao-climate-ai-policy-driving-sustainability-through-innovation'
    }
  ]
  const linksToShow = showPolicyLinks ? [...navLinks, ...policyLinks] : navLinks

  return (
    <nav className="w-full flex items-center">
      {/* Desktop nav */}
      <div className="hidden lg:flex w-full justify-end">
        <NavigationMenu>
          <NavigationMenuList className="gap-0">
            {linksToShow.map((link) => (
              <NavigationMenuItem key={link.label}>
                {link.dropdown ? (
                  <>
                    <NavigationMenuTrigger
                      className={`${robotoClass} bg-transparent border-none hover:bg-[#003B57] hover:text-white focus:bg-[#003B57] focus:text-white px-4 py-2 h-[40px] flex items-center gap-1`}
                    >
                      {link.label}
                    </NavigationMenuTrigger>
                    <NavigationMenuContent className="bg-[#002F45] border-none shadow-lg mt-2 rounded-none min-w-[180px]">
                      <ul className="flex flex-col py-2 mb-2">
                        {link.dropdown.map((item) => (
                          <li key={item.label}>
                            <NavigationMenuLink
                              href={item.href}
                              className={`${robotoClass} block px-6 py-2 text-white hover:bg-[#003B57] hover:text-white focus:bg-[#003B57] focus:text-white rounded transition-colors`}
                            >
                              {item.label}
                            </NavigationMenuLink>
                          </li>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </>
                ) : (
                  <NavigationMenuLink
                    href={link.href}
                    onClick={link.onClick || undefined}
                    target={link.href?.includes('http') || link.href?.includes('mailto') ? '_blank' : undefined}
                    className={`${robotoClass} cursor-pointer px-2 py-2 h-[40px] flex items-center hover:bg-[#003B57] hover:text-white focus:bg-[#003B57] focus:text-white rounded transition-colors`}
                  >
                    {link.label}
                  </NavigationMenuLink>
                )}
              </NavigationMenuItem>
            ))}
          </NavigationMenuList>
        </NavigationMenu>
      </div>
      {/* Mobile nav: vertical list */}
      <div className={`flex lg:hidden w-full justify-end ${showPolicyLinks ? 'mr-4' : 'mr-4'}`}>
        <div className="flex flex-col items-start gap-2">
          {linksToShow.map((link) =>
            link.dropdown ? (
              <div key={link.label} className="flex flex-col items-start gap-1">
                <span className={`${robotoClass} font-semibold`}>{link.label}</span>
                {link.dropdown.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    target={item.href?.includes('http') || item.href?.includes('mailto') ? '_blank' : undefined}
                    className={`${robotoClass} block px-6 py-2 text-white hover:bg-[#003B57] hover:text-white focus:bg-[#003B57] focus:text-white rounded transition-colors`}
                    rel="noreferrer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            ) : (
              <a
                key={link.label}
                href={link.href}
                target={link.href?.includes('http') || link.href?.includes('mailto') ? '_blank' : undefined}
                onClick={link.onClick || undefined}
                className={`${robotoClass} cursor-pointer px-2 py-0 h-[25px] flex items-center hover:bg-[#003B57] hover:text-white focus:bg-[#003B57] focus:text-white rounded transition-colors`}
                rel="noreferrer"
              >
                {link.label}
              </a>
            )
          )}
        </div>
      </div>
    </nav>
  )
}

export default Nav
